import {EntityCollectionServiceBase} from "@ngrx/data";
import {HttpModelConverter} from "../converter/httpModel.converter";
import {EntityCollectionFindOneByAttributeService} from "./entityCollectionFindOneByAttributeService";
import {DefaultDataservice} from "../../../store/core/dataservice/default.dataservice";

export abstract class EntityCollectionGetByIdService<T, C extends HttpModelConverter<T>> extends EntityCollectionFindOneByAttributeService<T, C> {


    protected constructor(serviceName: string, entityCollectionServiceBase: EntityCollectionServiceBase<T>, dataService: DefaultDataservice<T>, converter: C) {
        super(serviceName, entityCollectionServiceBase, dataService, converter);

    }

    protected getAttributeName(): string {
        return "id";
    }
}
